import { Dialog, Transition } from "@headlessui/react";
import { Notification } from "app/helpers/sendnotification";
import ProductService from "app/services/productService";

import React, { FC, Fragment, useEffect, useRef, useState } from "react";
import Input from "shared/Input/Input";



export interface ModalPriceProps {
  show: boolean;
  productId: number;
  onCloseModalPrice: () => void;
  onChangeClick: (p:number)=> void;
}

const ModalPrice: FC<ModalPriceProps> = ({
  show,
  productId,
  onCloseModalPrice,
  onChangeClick,
}) => {
 
    

  const [price, setPrice] = useState<number>(0)
    const onchnge = () =>{
   
      ProductService.changePrice({product_id: productId, price:price}).then(data =>{
        if(data.w == 0){
          Notification("success", "Le prix a été modifié!")
          onChangeClick(price)
        }
        if(data.w == 1){
          Notification("warning", "Vous ne pouvez pas mettre un prix plus élevé!")
        }

        
          
        onCloseModalPrice()
      })

       
        


    }

    return (
    <Transition appear show={show} as={Fragment}>
    <Dialog as="div" className="relative z-10" onClose={onCloseModalPrice}>
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-black bg-opacity-25" />
      </Transition.Child>

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
              <Dialog.Title
                as="h3"
                className="text-lg font-medium leading-6 text-gray-900"
              >
                changer le prix!
              </Dialog.Title>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                 ss
                </p>
                <Input
                    type="number"
                  
                    placeholder="1000"
                    name="price"
                    value={price} 
                    onChange={e => setPrice(parseInt(e.target.value))}
                   
                  />
              </div>

              <div className="mt-4">
                
                
                <button
                  type="button"
                  className=" mr-5  inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2"
                  onClick={onchnge}
                >
                  0ui vas-y
                </button>
                <button
                  type="button"
                  className=" inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                  
                  onClick={onCloseModalPrice} 
                >
                   Annuler
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition>

  );
};

export default ModalPrice;
